import React from 'react';
import {ArrowRight, Mail, Eye, LineChart, Folder} from 'lucide-react';
import {Link} from "react-router-dom";
import {LiaUserEditSolid} from "react-icons/lia";
import Swal from "sweetalert2";
import useApi from "../../../utils/useApi";
import {FaBarsProgress} from "react-icons/fa6";
import {IoDocuments} from "react-icons/io5";

const CustomerAccountActions = ({ user, className, includeProgressBtn = false, year }) => {
    return (
        <div className={`
        gap-4 w-full ${className ? className : ''}`}>

            {/* Main Actions */}
            <div className="flex flex-row flex-wrap gap-2 flex-grow mt-2">
                {includeProgressBtn && (
                    <Link
                        to={`/client-progress/${user.id}?year=${year}`}
                        className="flex-grow inline-flex items-center justify-center gap-2 px-4 py-2 text-white rounded-lg transition-colors text-center bg-indigo-500 dark:bg-indigo-600
                    text-white
                    text-xs
                    hover:bg-indigo-600 dark:hover:bg-indigo-700"
                    >
                        Dashboard <FaBarsProgress className="w-4 h-4"/>
                    </Link>
                )}
                <Link
                    to={`/my-documents?year=${year}`}
                    className="flex-grow inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white
                    text-xs
                    rounded-lg hover:bg-blue-700 transition-colors text-center"
                >
                    Documents <IoDocuments className="w-4 h-4"/>
                </Link>
                <Link
                    to={`/client/questionnaire/${user.id}?year=${year}`}
                    className="flex-grow inline-flex justify-center px-4 py-2 text-gray-700 dark:text-gray-200 border border-gray-200
                     text-xs
                     dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-center"
                >
                    Tax Questionnaire <i className="fas fa-newspaper ml-2"/>
                </Link>
            </div>
        </div>
    );
}



export default CustomerAccountActions;
